<template>
  <me-combo-tree v-bind="$props" v-on="$listeners" :data="comboData" />
</template>
<script>

import http from '@common/ExtendHttp'
import comboMixin from '../mixins/combo.mixin'
export default {
  mixins: [ comboMixin ],
  name: 'ComboTreeDepartment',
  props: {
    pathName: {
      type: String, default: '/authority/department/tree'
    }
  },
  data () {
    return {
      comboData: [],
      eventName: 'refresh--comno-tree-department'
    }
  },
  created () {
    this.$eventMonitor.register(this.eventName, data => {
      http.get(this.pathName).then(data => {
        this.comboData = data
      })
    })
    this.$eventMonitor.dispatch(this.eventName)
  }
}
</script>
